// X (x.com / twitter.com) and LinkedIn (/in/<slug>, /company/<slug>) profile links for the
// payment forms. Checked before the legacy regexes, one of which used to swallow
// twitter.com links as "telegram". Returns [platform, username] or null; the backend
// (routes/socialmedia.js) re-validates and does the lookup.
const X_PROFILE = /^https?:\/\/(?:www\.|mobile\.)?(?:x|twitter)\.com\/([A-Za-z0-9_]{1,15})\/?(?:\?.*)?$/i;
const X_RESERVED = new Set([
  "home", "explore", "i", "search", "notifications", "messages", "settings", "compose",
  "hashtag", "intent", "share", "login", "signup", "status", "lists", "bookmarks",
]);
const LINKEDIN_PROFILE = /^https?:\/\/(?:[a-z]{2,3}\.|www\.)?linkedin\.com\/(in|company)\/([^/?#]+)\/?(?:[?#].*)?$/i;

export const matchXOrLinkedinUrl = (url) => {
  const x = url.match(X_PROFILE);
  if (x && !X_RESERVED.has(x[1].toLowerCase())) return ["twitter", x[1]];

  const li = url.match(LINKEDIN_PROFILE);
  if (li) return ["linkedin", li[2]];

  return null;
};
